
import {deepClone, getOperator, globalConfig, headers} from "@/utils";
import {settings} from "@/settings";
import axios from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import moment from "moment";
import { api, apiAnonymousToken } from "@/auth/api";
import i18n from "@/i18n";
import { getBase64 } from "@/commons/gathering-process-order";
import store from "@/store";
import { extract, setOrderedRule, setRule } from "@/commons/businessRules";
import { initializeBusinessRuleSection } from "@/utils/queryBuilder";
import BusinessruleValueForm from "@/components/configuration/actions/actionCreation/BusinessruleValueForm.vue";
import { DocumentTypeWithAssociations } from "@/types";
const api_query_url = settings.api_query_url;
const supportingdocument = `odm-supportingdocument`
const orchestration = `odm-orchestration`
const baseUrl = `${settings.api_url}/${supportingdocument}/api/1/${supportingdocument}`
const orchestrationUrl = `${settings.api_url}/${orchestration}/business-api/1/`


      export function searchDocumentsType(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchDocumentsType(filter, offset, limit)
          const _headers = headers({
            qc: JSON.stringify(qc)
          })
          axios.get(url, {
            headers: _headers
          }).then(res => {
            resolve(res.data)
          }).catch(err => reject(err))
      })
    }

export function getQcSearchDocumentsType(filter: any, offset?: any, limit?: any): any {

      const qc_header: any = {
        qc: {
          queryId: "search-supportingdocument-supporting-type",
          offset: offset || 0,
          limit: limit || 100,

        },
      };
      qc_header.qc.parameters = {
        ...filter,
      };
      const operators:any = [];


      if (filter && filter.documentType) {
        operators.push(
            getOperator(
              "lower(supportingdocument_document_type",
              "id)",
              "LIKE",
              globalConfig.formatters
                .getEqualValue("%" + filter.documentType + "%")
                .toLowerCase(),
              "id"
            )
          );
      }

      if (filter && filter.whenCreated && filter.whenCreated.from) {
        operators.push(
          getOperator(
            "supportingdocument_document_type",
            "_when_created",
            "GREATER_THAN_EQUAL",
            globalConfig.formatters.getEqualValue(moment(filter.whenCreated.from,  'DD/MM/YYYY').format('YYYY-MM-DD')),
            "whencreated"
          )
        );
      }
      if (filter && filter.whenCreated && filter.whenCreated.to) {
        operators.push(
          getOperator(
            "supportingdocument_document_type",
            "_when_created",
            "LESS_THAN_EQUAL",
            globalConfig.formatters.getEqualValue(moment(filter.whenCreated.to,  'DD/MM/YYYY').format('YYYY-MM-DD')),
            "whencreated"
          )
        );
      }


      if (operators.length > 0) {
        qc_header.qc.otherFilters = {
          expressions: [
            {
              and: {
                operators,
              },
            },
          ],
        };
      }

return qc_header.qc;
}
export async function concatFile(payload: any){
  let base64:any=''
  const authName= store.getters["authModule/getAuthName"];

  if(payload.file && payload.file.content){
    base64 =payload.file.content
  }else{
    base64 = await getBase64(payload.file);
  }

  let body = {
    fileName: payload.doc.comment || payload.file.name,
    processId: payload.doc.processResourceUid,
    documentTypeId: payload.doc.documentType,
    receivedFileId:payload.doc.receivedFilesUid,
    createUser:authName,
    content: base64
  };
    Notify.create({
                       message: i18n.global.t("order.messages.concatBegin"),
                       color: "positive",
    })
  const result =await replaceFile(body);
     Notify.create({
                       message: i18n.global.t("order.messages.concatEnd"),
                       color: "positive",
    })
    payload && payload.filePanelIndex !== undefined && payload.filePanelIndex !== null && payload.filePanelIndex !== ''
    && Number.isInteger(Number(payload.filePanelIndex)) && Number(payload.filePanelIndex) >= 0
    ? store.dispatch("taskModule/uploadDocumentModule/removeFile",  { index: Number(payload.filePanelIndex) })
    : null


 return result
}
export async function replaceFile(payload: any) {
  return api().post(`${orchestrationUrl}/uploadDoc/`, payload)
}
export async function  createDocumentsType(documentType: any) {
  return apiAnonymousToken().post(`${baseUrl}/documenttype/`, documentType)
}

export async function  getDocumentType(resourceUid: any) {
  return api().get(`${baseUrl}/documenttype/${resourceUid}/`)
}

export async function  updateDocumentType(resourceUid: any, documentType: any) {
  return apiAnonymousToken().put(`${baseUrl}/documenttype/${resourceUid}/`, documentType)
}

export async function  deleteDocumentType(resourceUid: any) {
  return api().delete(`${baseUrl}/documenttype/${resourceUid}/`)
}

export async function  createDocumentsFamily(documentFamily: any) {
  return apiAnonymousToken().post(`${baseUrl}/supportingdocumentfamily/`, documentFamily)
}
export async function  getDocumentsFamily(resourceUid: any) {
  return api().get(`${baseUrl}/supportingdocumentfamily/`+resourceUid+'/')
}

export async function  createAssociation(parentResourceUid:any,documentFamily: any) {
  return apiAnonymousToken().post(`${baseUrl}/documenttype/`+parentResourceUid+'/supportingtype/', documentFamily)
}
export async function  updateAssociation(resourceUid:any,documentFamily: any) {
  return apiAnonymousToken().put(`${baseUrl}/supportingtype/`+resourceUid+'/', documentFamily)
}
export async function  deleteAssociation(resourceUid:any) {
  return api().delete(`${baseUrl}/supportingtype/`+resourceUid+'/')
}

export async function  getSupportingTypesByDocumentType(documentTypeId: any): Promise<any[]> {
  const filter = {
    document_type_id: documentTypeId,
    request: "documentTypeAssociations"
  }
  return searchDocumentFamily(filter)
}

export async function  getDocumentTypeWithAssociations(documentTypeId: string) : Promise<DocumentTypeWithAssociations> {
  try {
    const documentType = await getDocumentType(documentTypeId)
    const associations: any[] = await getSupportingTypesByDocumentType(documentTypeId)

    console.log('DocumentType:', documentType);
    console.log('Associations:', associations);

    const selectedFamilies = []
    if (associations && Array.isArray(associations) && associations.length > 0) {
      // Initialize business rule sections
      for (const assoc of associations) {
        if (assoc.documentfamilyid) {
          try {
            initializeBusinessRuleSection(assoc.documentfamilyid)
          } catch (e) {
            console.warn('Could not initialize business rule section:', e)
          }
        }
      }

      for (const assoc of associations) {
        if (assoc.documentfamilyid) {
      const assocBusinessDataRaw = assoc.business_data;
      let assocBusinessData: any = {};
      if (typeof assocBusinessDataRaw === "string") {
        try {
          assocBusinessData = JSON.parse(assocBusinessDataRaw);
        } catch {
          assocBusinessData = {};
        }
      } else if (assocBusinessDataRaw && typeof assocBusinessDataRaw === "object") {
        assocBusinessData = assocBusinessDataRaw;
      }

      const documents_by_family = typeof assoc?.documents_by_family === 'string'
      ? JSON.parse(assoc.documents_by_family)
      : (assoc.documents_by_family || []);

      const displayOrderOptions = [];

      // On fait une boucle de 1 jusqu'au nombre total d'objets
      for (let i = 1; i <= documents_by_family.length + 1; i++) {

          // On cherche dans tout le tableau s'il existe un document
          // dont le "display_order" original est égal à "i"
          const docWithThisOrder = documents_by_family.find((item:any) => item.display_order === i);

          displayOrderOptions.push({
              label: i.toString(),
              value: i,
              // Si on a trouvé un document qui avait cet ordre, on met son ID, sinon null
              document_type_id: docWithThisOrder ? docWithThisOrder.document_type_id : null
          });
      }
          const familyItem: any = {
            value: assoc.documentfamilyid,
            label: assoc.documentfamilyid,
            isTrue: assoc.mandatory || false,
            resourceUid: assoc.documenttypeid || '',
            config: assoc,
            proofLevel: assoc.prooflevel || 100,
            toBeSigned: assoc.to_be_signed,
            // Préserve l'indicateur "à valider" (colonne to_be_validated) dans le round-trip :
            // sans ça, il n'était ni relu ni réécrit et le PUT le remettait à false.
            toBeValidated: assoc.to_be_validated ?? false,
            acceptClientUpload:
              assocBusinessData.acceptClientUpload || false,
            autoSigned: assoc.auto_signed || false,
            folderCode: assoc.foldercode || '',
            manual: assoc.manual || false,
            displayBR: assoc.displaybr || null,
            displayOrder: assoc?.display_order || null,
            nbrOfPages: assoc?.nbr_of_pages || null,
            validity: {
              from: assoc.validity_from
                ? moment(assoc.validity_from, 'YYYY-MM-DD').format('DD/MM/YYYY')
                : null,
              until: assoc.validity_until
               ?  moment(assoc.validity_until, 'YYYY-MM-DD').format('DD/MM/YYYY')
                  : null,
            },
            documents_by_family: documents_by_family,
            displayOrderOptions: displayOrderOptions,
            document_type: assoc.document_type_id,
            rolesAllowed: assoc.roles_allowed || '',
            rolesAllowedList: assoc.roles_allowed
              ? assoc.roles_allowed.split(';').map((r: string) => r.trim()).filter(Boolean)
              : [],
            documentStatus: assoc.document_status || assoc.documentStatus || '',
            documentStatusList: (assoc.document_status || assoc.documentStatus)
              ? String(assoc.document_status || assoc.documentStatus).split(';').map((r: string) => r.trim()).filter(Boolean)
              : []
          }

          selectedFamilies.push(familyItem)
        }
      }
    }

    const result = {
      ...documentType.data,
      selectedFamilies: selectedFamilies
    }

    console.log('getDocumentTypeWithAssociations result:', result);
    return result;
  } catch (error) {
    console.error('Error in getDocumentTypeWithAssociations:', error);
    throw error;
  }
}

export const BusnissRuleDocumentValueKeys: string[] = ["displayed"];
export const outputFormDocumentConfiguration: any = {
  displayed: ["displayed"],
};

export const createDocumentTypeAssociations = async (payload: any) => {
  const list = []
  const documentType = await getDocumentTypeWithAssociations(payload.resourceUid)

  if (documentType && documentType.selectedFamilies) {
    for (const family of documentType.selectedFamilies) {
      const familyExists = payload.selectedFamilies.some(
        (payloadFamily: any) => payloadFamily.resourceUid === family.resourceUid
      );
      if (!familyExists) {
        await deleteAssociation(family.config.documenttypeid);
      }
    }
  }

  for (const family of payload.selectedFamilies) {
    const familyBusinessDataRaw =  family?.config?.business_data;
    let familyBusinessData: any = {};
    if (typeof familyBusinessDataRaw === "string") {
      try {
        familyBusinessData = JSON.parse(familyBusinessDataRaw);
      } catch {
        familyBusinessData = {};
      }
    } else if (familyBusinessDataRaw && typeof familyBusinessDataRaw === "object") {
      familyBusinessData = familyBusinessDataRaw;
    }

    const body: any = {
      proofLevel: family.proofLevel || 100,
      manual: family.manual || false,
      mandatory: family.isTrue || false,
      toBeSigned: family.toBeSigned || false,
      // Réémet l'indicateur "à valider" existant (updateAssociation étant un PUT full-replace,
      // l'omettre le réinitialisait à false, notamment en cochant "à signer").
      toBeValidated: family.toBeValidated ?? family.config?.to_be_validated ?? false,
      businessData: {
        ...familyBusinessData,
        acceptClientUpload: family.acceptClientUpload ? true : false,
      },
      autoSigned: family?.autoSigned || false,
      folderCode: family.folderCode || '',
      displayOrder: family?.displayOrder,
      nbrOfPages: family?.nbrOfPages,
      rolesAllowed: family?.rolesAllowed,
      documentStatus: family?.documentStatus,
      validity: {
              from:
                family.validity && family.validity.from
                  ? moment(family.validity.from, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : null,
              until:
                family.validity && family.validity.until
                  ?  moment(family.validity.until, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : null,
      },
      supportingDocument: {
        objectType: "odm.supportingdocument.supportingdocumentfamily",
        systemUid: "odm-supportingdocument",
        resourceUid: family.value,
      },
      objectType: "odm.supportingdocument.supportingtype",
      systemUid: "odm-supportingdocument",
      daaq: "/",
      resourceUid: family.resourceUid
    }
    if (family.displayBR) {
      body.displayBR = {
        rule: typeof family.displayBR === "string" ? JSON.parse(family.displayBR) : family.displayBR,
        ruleEngineId: null
      }
    }

    if (body.resourceUid === '') {
      delete body.resourceUid
    }

    let association
    if (family.config && family.config.documenttypeid) {
      body.resourceUid = family.config.documenttypeid
      association = await updateAssociation(family.config.documenttypeid, body).then((res: any) => {

      }).catch(err => {
        Notify.create({
          message: "erreur",
          color: 'negative'
        })
      })
    } else {
      association = await createAssociation(payload.resourceUid, body).then((res: any) => {
        Notify.create({
          message: i18n.global.t('main.dialog.success', { entity: res.data?.resourceUid }),
          color: 'positive'
        })
      }).catch(err => {
        Notify.create({
          message: "erreur",
          color: 'negative'
        })
      })
    }

    list.push(association)
  }

  const documentTypeEdit = await getDocumentTypeWithAssociations(payload.resourceUid)
  return documentTypeEdit
}

export const createAssociationMethode = async (payload: any) => {
  const list=[]
  const documentFamily= await getAssociation(payload.resourceUid)
  if (documentFamily && documentFamily.selectedDocuments){
    for (const doc of documentFamily.selectedDocuments) {
      const docExists = payload.selectedDocuments.some(
        (payloadDoc:any) => payloadDoc.resourceUid === doc.resourceUid
      );
      if (!docExists) {
        await deleteAssociation(doc.config.documenttypeid);
      }
    }
  }

  for(const doc of payload.selectedDocuments){
    const body:any={
      proofLevel: 100,
      manual:false ,
      mandatory: doc.isTrue,
      displayBR: {
        rule: store.state.queryBuilderModule.queryBuilder[doc.value].selectedBuisinessRule,
        ruleEngineId: null
      } ,
      supportingDocument: {
        objectType: "odm.supportingdocument.supportingdocumentfamily",
        systemUid: "odm-supportingdocument",
        resourceUid: payload.resourceUid,
      },
      objectType: "odm.supportingdocument.supportingtype",
      systemUid: "odm-supportingdocument",
      daaq: "/",
      resourceUid: doc.resourceUid
    }
    if (body.resourceUid === ''){
      delete body.resourceUid
    }
    let association
    if(doc.config&&doc.config.documenttypeid){
      body.resourceUid=doc.config.documenttypeid
      association = await updateAssociation(doc.config.documenttypeid,body).then((res: any) => {
        Notify.create({
          message: i18n.global.t('main.dialog.success', { entity: res.data?.resourceUid }),
          color: 'positive'
        })
      }).catch(err => {
            Notify.create({
                  message: "erreur",
                  color: 'negative'
                })
              })

    }else{
     association = await createAssociation(doc.value,body).then((res: any) => {
      Notify.create({
        message: i18n.global.t('main.dialog.success', { entity: res.data?.resourceUid }),
        color: 'positive'
      })
    }).catch(err => {
          Notify.create({
                message: "erreur",
                color: 'negative'
              })
            })
    }

    list.push(association)
  }
  const documentFamilyEdit= await getAssociation(payload.resourceUid)
  return documentFamilyEdit

}
export async function  getAssociation(id: any) {
  const filter={
    documentfamilyid:id,
    request: "documentTypeAssociations"
  }
  const documentFamilyList:any =await searchDocumentFamily(filter)
  if(documentFamilyList&&documentFamilyList.length>0){
    const listDoc=[]

    for(const documentFamily of documentFamilyList){
    initializeBusinessRuleSection(documentFamily.document_type_id)
   }
    for(const documentFamily of documentFamilyList){
      if(documentFamily.document_type_id){


        const docFamily : any  =
          {value:documentFamily.document_type_id,
            label:documentFamily.document_type_id ,
            isTrue:documentFamily.mandatory,
            resourceUid:documentFamily.documenttypeid,
            config:documentFamily
          }





        if (documentFamily.displaybr) {

              (
                store.state.queryBuilderModule.queryBuilder[
                  documentFamily.document_type_id as any
                ] as any
              ).selectedBuisinessRule = JSON.parse(documentFamily.displaybr);

            const extracRule = extract(
              JSON.parse(documentFamily.displaybr),
              buisinessRuleDocumentResults
            );
            store.dispatch("queryBuilderModule/setbrResluts", {
              extracRule: extracRule,
              currentSection: documentFamily.document_type_id,
            });
            docFamily.displaybr = extracRule[0] || {};
            docFamily.displaybr.advancedConfigurationToggle = true;


            docFamily.ruleContextParams=

                        {
                          ruleOutputHeaderContext: documentFamily.displaybr,
                          ruleOutputKeys: BusnissRuleDocumentValueKeys,
                            results:  {displayed: true} ,
                            initResults: deepClone(buisinessRuleDocumentResults),
                          outputFormConfiguration: outputFormDocumentConfiguration,
                          translateContextKey: 'asset.Residualvalue',
                          currentSection: documentFamily.document_type_id,
                          ruleOutputComponent: BusinessruleValueForm
                        }


        }

        listDoc.push(docFamily)
      }




    }
    const documentFamilyEdit= {
      objectType: "odm.supportingdocument.supportingdocumentfamily",
    systemUid: "odm-supportingdocument",
    resourceUid: id,
    reference:id,
    daaq:"/",
    isMandatory:documentFamilyList[0].mandatory,
    selectedDocuments:listDoc
    }
    return documentFamilyEdit
  }

}

const buisinessRuleDocumentResults = {
  displayed: true,

};

export function getQcSearchDocumentFamilyList(filter: any, offset?: any, limit?: any): any {
    const qc_header: any = {
      qc: {
        queryId: "search-supportingdocument-document-family-list",
        offset: offset || 0,
        limit: limit || 100,

      },
    };
    qc_header.qc.parameters = {
      ...filter,
    };
    const operators:any = [];

    if (filter && filter?.documentfamilyid) {
      operators.push(getOperator("lower(supportingdocument_supporting_document_family", "id)", "LIKE", globalConfig.formatters.getEqualValue('%' +filter?.documentfamilyid + '%').toLowerCase(), ""))
    }

    if (filter && filter?.documenttypeid) {
      operators.push(getOperator("lower(supportingdocument_supporting_type", "id)", "LIKE", globalConfig.formatters.getEqualValue('%' +filter?.documenttypeid + '%').toLowerCase(), ""))
    }

    if (filter && filter?.document_type_id) {
      operators.push(getOperator("lower(supportingdocument_supporting_type", "document_type_id)", "LIKE", globalConfig.formatters.getEqualValue('%' +filter?.document_type_id + '%').toLowerCase(), ""))
    }


    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators,
            },
          },
        ],
      };
    }
    return qc_header.qc;
}

      export function searchDocumentFamilyList(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchDocumentFamilyList(filter, offset, limit)
          const _headers = headers({
            qc: JSON.stringify(qc)
          })
        axios
          .get(url, {
            headers: _headers,
          })
          .then((res) => {
            const response : any[] =[]
            for (const resItem of res.data){
              let accessory = ''
              const displayOrderOptions = [];
                const documents_by_family = typeof resItem?.documents_by_family === 'string'
                 ? JSON.parse(resItem.documents_by_family)
                 : (resItem.documents_by_family || []);
              if (resItem.document_type_id) {

                const accessories =  JSON.parse(resItem.document_type_id);
                accessory = accessories.length ===1 && accessories[0] === null
                ? ''
                : accessories.filter((item:any) => item !== null).join(', ');
            }

             if (resItem.documents_by_family) {
                    for (let i = 1; i <= documents_by_family.length + 1; i++) {

                        const docWithThisOrder = documents_by_family.find((item:any) => item.display_order === i);

                        displayOrderOptions.push({
                            label: i.toString(),
                            value: i,
                            document_type_id: docWithThisOrder ? docWithThisOrder.document_type_id : null
                        });
                    }
                  }
              else {
                displayOrderOptions.push({
                        label: "1",
                        value: 1,
                        document_type_id: null
                });
              }

            response.push({
                  documentfamilyid: resItem.documentfamilyid,
                  document_type_id: accessory,
                  documents_by_family: documents_by_family,
                  displayOrderOptions: displayOrderOptions,
                  document_type: resItem.document_type_id

            })
            }
            resolve(response);
          })
          .catch((err) => {
              Notify.create({
                message: `Query returned an error \n ${err}`,
                color: "negative",
              });
            });
      });
      }

export function searchDocumentFamily(filter: any): Promise<any[]> {
  return new Promise<any[]>(async (resolve, reject) => {
    const url = settings.api_query_url;
    const qc_header: any = {
      qc: {
        queryId: "search-supportingdocument-document-family-new",
      },
    };
    qc_header.qc.parameters = {
      ...filter,
    };
    const operators:any = [];

    if (filter && filter?.documentfamilyid) {
      if (filter && filter?.request === "documentTypeAssociations"){
        operators.push(getOperator("lower(supportingdocument_supporting_document_family", "id)", "EQUAL", globalConfig.formatters.getEqualValue(filter?.documentfamilyid).toLowerCase(), ""))
      }
      else {
      operators.push(getOperator("lower(supportingdocument_supporting_document_family", "id)", "LIKE", globalConfig.formatters.getEqualValue('%' +filter?.documentfamilyid + '%').toLowerCase(), ""))
      }
    }

    if (filter && filter?.documenttypeid) {
      operators.push(getOperator("lower(supportingdocument_supporting_type", "id)", "LIKE", globalConfig.formatters.getEqualValue('%' +filter?.documenttypeid + '%').toLowerCase(), ""))
    }

    if (filter && filter?.document_type_id) {
      if (filter && filter?.request === "documentTypeAssociations"){
        operators.push(getOperator("lower(supportingdocument_supporting_type", "document_type_id)", "EQUAL", globalConfig.formatters.getEqualValue(filter?.document_type_id).toLowerCase(), ""))
      }
      else {
        operators.push(getOperator("lower(supportingdocument_supporting_type", "document_type_id)", "LIKE", globalConfig.formatters.getEqualValue('%' +filter?.document_type_id + '%').toLowerCase(), ""))

      }
    }


    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators,
            },
          },
        ],
      };
      qc_header.qc.otherOrders = null;
      qc_header.qc.offset = 0;
      qc_header.qc.limit = 100;
    }

    const _headers = headers({
      qc: JSON.stringify(qc_header.qc),
    });

    axios
      .get(url, {
        headers: _headers,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
          Notify.create({
            message: `Query returned an error \n ${err}`,
            color: "negative",
          });
        });
  });
}

function intiValidity(body: any) {
    body.validity = {
      from: null,
      until: null
    }
  }
  const normalizeDate = (date: string | null) => {
  if (!date) return null;
  // Si déjà au format YYYY-MM-DD
  if (moment(date, 'YYYY-MM-DD', true).isValid()) return date;
  // Sinon, convertir depuis DD/MM/YYYY
  if (moment(date, 'DD/MM/YYYY', true).isValid())
    return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
  return null;
};

export const executUpdateDocumentsType = async (resourceUid: any, documentType: any) => {

  if (documentType && documentType?.supportingType && documentType?.supportingType.length > 0){
    for (const supportingType of documentType?.supportingType ){
      if (! supportingType.validity) {
            intiValidity(supportingType)
         }
      else {
        const validity = {
          from: normalizeDate(supportingType.validity?.from || null),
          until: normalizeDate(supportingType.validity?.until || null),
        };
        supportingType.validity = validity
      }
    }
  }
   return await updateDocumentType(resourceUid, documentType)
}
export async function documentTypeExists(resourceUid: string): Promise<boolean> {
  try {
    const res: any = await getDocumentType(resourceUid);
    return res && res.data && res.data.resourceUid ? true : false
  } catch {
    return false;
  }
}

